import { render } from "./EventGameDashboard.vue?vue&type=template&id=52e13f66&scoped=true"
import script from "./EventGameDashboard.vue?vue&type=script&lang=js"
export * from "./EventGameDashboard.vue?vue&type=script&lang=js"

import "./EventGameDashboard.vue?vue&type=style&index=0&id=52e13f66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e13f66"]])

export default __exports__